import { championshipReadNote } from './championshipReadView.js'
import { emptyReason } from '../../lib/emptyReason.js'
import styles from './ScopeNote.module.css'

/**
 * WHY THIS COUNT IS WHAT IT IS — the rendered half of lib/emptyReason.js.
 *
 * ⚠️ A COMPONENT RATHER THAN INLINE JSX, AND THE REASON IS SCREENSHOTS AS MUCH
 * AS REUSE. Inlined in CommandCenter it could only be SHOWN by signing in and
 * engineering a 401 — so the one piece of work whose whole purpose is being
 * legible to a rep was the piece nobody could look at. As a component the dev
 * harness mounts the SHIPPED code with a fixture, and what Brian sees in a
 * screenshot is the same component production renders rather than a mock-up of
 * it.
 *
 * Every verdict comes from `emptyReason`, which never infers scoping from a
 * count. This file only draws, and `data-kind` is what makes the three voices
 * visually distinct — two different facts looking identical was the defect.
 */
export default function ScopeNote({ count, loading, loadError, role, bookMeta, book, noun = 'records', championshipRead = false, readScope, complete, collapsible = true }) {
  const r = championshipRead
    ? championshipReadNote({ count, loading, loadError, scope: readScope, complete })
    : emptyReason({ count, loading, loadError, role, bookMeta, book, noun })
  if (!r.headline && !r.detail) return null
  if (collapsible && championshipRead && r.kind !== 'error') return (
    <details className={`${styles.note} ${styles.readDisclosure}`} data-kind={r.kind} data-testid="scope-note">
      <summary><strong>{r.headline}</strong>{readScope?.rep ? ` · ${readScope.rep}` : ''}{count != null ? ` · ${count.toLocaleString()} loaded` : ''} · read-only</summary>
      <p>{r.detail}</p>
    </details>
  )
  return (
    <div
      className={styles.note}
      data-kind={r.kind}
      data-testid="scope-note"
      role={r.kind === 'error' ? 'alert' : 'status'}
    >
      {r.headline && <strong>{r.headline}</strong>}
      {r.headline && r.detail ? ' ' : ''}
      {r.detail}
    </div>
  )
}
